import { SideSelectorStyled } from "./styled/SideSelectorStyled.js";
import { Fragment, memo, useCallback, useEffect, useState } from "react";
import { LITE_TRADE_POSITION_SIDE } from "../../modules/LiteTrade/liteTradeConstants.js";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import _ from "lodash";

function SideSelector(props) {
    const {
        side: initSide,
        onChange,
    } = props;

    const [side, setSide] = useState(initSide);
    const {getLangPath} = useLangContext();

    const setSideHandler = useCallback((newSide) => {
        if (newSide !== side) {
            setSide(newSide);
            onChange(newSide);
        }
    }, [onChange, side]);

    const onChangeHandler = useCallback((e) => {
        const newSide = e.currentTarget.dataset.side;
        setSideHandler(newSide);
    }, [setSideHandler]);

    useEffect(() => {
        if (!LITE_TRADE_POSITION_SIDE[side]) {
            setSideHandler(LITE_TRADE_POSITION_SIDE.BUY);
        }
    }, [setSideHandler, side]);

    return <SideSelectorStyled>
        {
            Object.values(LITE_TRADE_POSITION_SIDE).map(item => <Fragment key={item}>
                <div className={side === item ? 'selected' : ''}
                     onClick={onChangeHandler}
                     data-side={item}
                >{getLangPath(`lite_version.order.${_.toLower(item)}`)}</div>
            </Fragment>)
        }
    </SideSelectorStyled>
}

export default memo(SideSelector);
